const AutoTagIcon = (): JSX.Element => {

return (
<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_8630_586" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
<rect x="0.5" width="24" height="24" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_8630_586)">
<path d="M11.45 13.6442L16.0443 9.05L14.975 7.99625L11.45 11.5308L10.025 10.1057L8.95575 11.175L11.45 13.6442ZM6 20.25V5.30775C6 4.80258 6.175 4.375 6.525 4.025C6.875 3.675 7.30258 3.5 7.80775 3.5H17.1923C17.6974 3.5 18.125 3.675 18.475 4.025C18.825 4.375 19 4.80258 19 5.30775V20.25L12.5 17.4615L6 20.25ZM7.5 17.95L12.5 15.8L17.5 17.95V5.30775C17.5 5.23075 17.4679 5.16025 17.4038 5.09625C17.3398 5.03208 17.2692 5 17.1923 5H7.80775C7.73075 5 7.66025 5.03208 7.59625 5.09625C7.53208 5.16025 7.5 5.23075 7.5 5.30775V17.95Z" fill="#999B9F"/>
</g>
</svg>
)
}
export default AutoTagIcon;